import React from "react";
import { Box, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
export const IconText = ({ icon, text, iconSize = 24, iconColor = "#454F5B", customIcon, sx, }) => {
    return (React.createElement(Box, { sx: Object.assign({ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0 }, sx) },
        customIcon ? (customIcon) : (icon && (React.createElement(Icon, { icon: icon, width: iconSize, color: iconColor, style: { flexShrink: 0 } }))),
        React.createElement(Typography, { variant: "body2", color: "text.secondary", noWrap: true, sx: { minWidth: 0 } }, text)));
};
